export function initContact() {
    for (const container of document.querySelectorAll('.contact-person-qr')) {
        /** @type {HTMLButtonElement} */
        const button = container.querySelector('.contact-person-qr-button');
        const dialog = container.querySelector('dialog');

        button.addEventListener('click', () => {
            dialog.showModal();
        });
    }
}
